import { Box } from '@givebutter/primitives/box';
import { Label } from '@givebutter/primitives/label';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Collapsible from '@radix-ui/react-collapsible';
import { twMerge } from 'tailwind-merge';

const ActivityItem = ({ children, className, ...props }: Collapsible.CollapsibleProps) => {
    return (
        <Collapsible.Root {...props} asChild>
            <Box className={twMerge('flex flex-col p-2', className)}>{children}</Box>
        </Collapsible.Root>
    );
};

const ActivityItemTrigger = ({
    children,
    className,
    disabled,
    ...props
}: Collapsible.CollapsibleTriggerProps) => {
    return (
        <Collapsible.Trigger
            className={twMerge(
                'group flex flex-grow items-center justify-between gap-2 p-2',
                !disabled && 'cursor-pointer',
                className,
            )}
            disabled={disabled}
            {...props}
        >
            <div className="flex flex-grow items-center gap-4">{children}</div>
            {!disabled && (
                <FontAwesomeIcon
                    className="group-radix-state-open:rotate-180 transition-all"
                    icon={faChevronDown}
                />
            )}
        </Collapsible.Trigger>
    );
};

const ActivityItemContent = ({
    children,
    className,
    ...props
}: Collapsible.CollapsibleContentProps) => {
    return (
        <Collapsible.Content asChild {...props}>
            <div
                className={twMerge(
                    'flex flex-1 flex-col gap-4 border-t border-t-gray-200 p-4',
                    className,
                )}
            >
                {children}
            </div>
        </Collapsible.Content>
    );
};

const ActivityItemIcon = ({ className, ...props }: React.HTMLProps<HTMLDivElement>) => {
    return (
        <div
            className={twMerge(
                'flex h-10 w-10 shrink-0 items-center justify-center rounded-full',
                className,
            )}
            {...props}
        />
    );
};

const ActivityItemNote = ({ children, ...props }: React.HTMLProps<HTMLDivElement>) => (
    <div {...props}>
        <Label>Note</Label>
        <p>{children}</p>
    </div>
);

const ActivityItemActions = ({
    children,
    className,
    ...props
}: React.HTMLProps<HTMLDivElement>) => (
    <div className={twMerge('flex items-center justify-end gap-4', className)} {...props}>
        {children}
    </div>
);

const Root = ActivityItem;
const Trigger = ActivityItemTrigger;
const Content = ActivityItemContent;
const Icon = ActivityItemIcon;
const Note = ActivityItemNote;
const Actions = ActivityItemActions;

export {
    ActivityItem,
    ActivityItemTrigger,
    ActivityItemContent,
    ActivityItemIcon,
    ActivityItemNote,
    ActivityItemActions,
    //
    Root,
    Trigger,
    Content,
    Icon,
    Note,
    Actions,
};
